import React from "react";
import createReactClass from "create-react-class";

import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  handleFacebookRegistrationConfirmation: function() {
    this.modalAlertFacebookRegistration.openModal();
  },
  redirect_to_facebook: function() {
    location.href = "/users/auth/facebook";
  },
  render() {
    return (
      <div>
        <a
          className="btn btn-lg btn-facebook-login"
          onClick={this.handleFacebookRegistrationConfirmation}
        >
          Facebookアカウントで登録
        </a>

        <ModalAlert
          ref={(c) => {
            this.modalAlertFacebookRegistration = c;
          }}
          title="注意"
          content="メールアドレスをつなげーとが取得します。取得の許可をしないとログインができないのでご注意ください。"
          approveFunc={this.redirect_to_facebook}
        />
      </div>
    );
  },
});
